export const checkIsModifierStrategy = (strategy?: string | null) => {
  return strategy === 'Treat' || strategy === 'Transfer';
};
